import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslocoPipe } from '@jsverse/transloco';
import { IOrgCriteriaDTO, IOrgModel, OrgService } from '@libs/vc-org-lib';
import { isEmpty } from 'lodash-es';
import { finalize, take } from 'rxjs';
import { ButtonComponent, InputComponent } from 'vcp-common-ui-lib';
import { OrgPickerComponent } from '../org-picker/org-picker.component';

@Component({
    selector: 'vc-org-picker-selector',
    imports: [TranslocoPipe, OrgPickerComponent, MatFormFieldModule, InputComponent, ButtonComponent],
    templateUrl: './org-picker-selector.component.html',
    styleUrls: ['./org-picker-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgPickerSelectorComponent {
    private readonly _orgService: OrgService = inject(OrgService);
    private readonly _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private _fetchDebouncer!: NodeJS.Timeout;

    orgOptions = [] as IOrgModel[];
    orgDialogVisible = false;
    loadingOrgs = false;

    @Input()
    org!: IOrgModel | null;

    @Input()
    searchByFilter: boolean = false;

    @Input()
    minimalStyles: boolean = true;

    @Input()
    hideDescription: boolean = false;

    @Output()
    orgChange = new EventEmitter<IOrgModel | null>();

    showOrgPicker() {
        if (isEmpty(this.orgOptions)) {
            this.getOrgs();
        }
        this.orgDialogVisible = true;
    }

    getOrgs(name?: string): void {
        if (!name) return;

        const criteria = {} as IOrgCriteriaDTO;
        if (name) {
            criteria.name = name;
        }
        const timing = name === '' ? 0 : 1000;

        clearTimeout(this._fetchDebouncer);
        this._fetchDebouncer = setTimeout(() => {
            this.loadingOrgs = true;
            this._changeDetectorRef.markForCheck();
            this._orgService
                .searchOrgs(criteria)
                .pipe(
                    take(1),
                    finalize(() => {
                        this.loadingOrgs = false;
                        this._changeDetectorRef.markForCheck();
                    })
                )
                .subscribe({
                    next: (orgList: IOrgModel[]) => {
                        this.orgOptions = orgList;
                    },
                });
        }, timing);
    }
}
